import { ShapePlusIcon } from './ShapePlusIcon';

/**
 * author: Austin Andrews
 * id C91D9DCD-5ADA-4D48-857C-39D38CD37A6B
 * name shape-plus
 * version: 1.5.54
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/shape-plus.svg
 * tags
 * - Shape 
 */
export const ShapeAddIcon = ShapePlusIcon;
export default ShapeAddIcon